<template>
    <section id="page5">
        <div class="container">
            <div class="col-left">
                <div>
                   <lottie-player :src="`animas/0/page06.json`" v-if="persona==0" ref="lottiepage6" id="page6anima0" class="anima"
                        loop="false"
                        transparent
                        >
                    </lottie-player>
                    <lottie-player :src="`animas/1/page06.json`" v-if="persona==1" ref="lottiepage6" id="page6anima1" class="anima"
                        loop="false"
                        transparent
                        >
                    </lottie-player>
                    
                </div>
            </div>
            <div class="col-right">
                <h2>
                    Um mooooooonte de vantagens para a sua empresa!
                </h2>
                <p>
                    Tudo o que fazemos é com foco no desenvolvimento dos colaboradores e nos benefícios que o aprendizado vai trazer para as empresas.
                </p>
            </div>
        </div>
        <div class="container container-bottom" data-aos="fade" data-aos-delay="600">
            <div class="swipercards">
                <swiper ref="mySwiper" :options="swiperOptions" @slideChange="runOnChange">
                    <swiper-slide>
                        <article>
                            <div class="card" data-aos="flip-left" data-aos-delay="300">
                                <img src="@/assets/img/page5-icon1.svg" alt="">
                                <p>
                                    Desenvolve e engaja as pessoas
                                </p>
                            </div>
                        </article>
                    </swiper-slide>
                    <swiper-slide>
                        <article>
                            <div class="card" data-aos="flip-left" data-aos-delay="400">
                                <img src="@/assets/img/page5-icon2.svg" alt="">
                                <p>
                                    Apoia na integração de novos colaboradores
                                </p>
                            </div>
                        </article>
                    </swiper-slide>
                    <swiper-slide>
                        <article>
                            <div class="card" data-aos="flip-left" data-aos-delay="500">
                                <img src="@/assets/img/page5-icon3.svg" alt="">
                                <p>
                                    Viabiliza trilhas adaptativas de desenvolvimento
                                </p>
                            </div>
                        </article>
                    </swiper-slide>
                    <swiper-slide>
                        <article>
                            <div class="card" data-aos="flip-left" data-aos-delay="600">
                                <img src="@/assets/img/page5-icon5.svg" alt="">
                                <p>
                                    Proporciona uma experiência inovadora de aprendizado
                                </p>
                            </div>
                        </article>
                    </swiper-slide>
                    <swiper-slide>
                        <article>
                            <div class="card" data-aos="flip-right" data-aos-delay="350">
                                <img src="@/assets/img/page5-icon7.svg" alt="">
                                <p>
                                    Mapeia conhecimentos, perfis, habilidades e <em>gaps</em>
                                </p>
                            </div>
                        </article>
                    </swiper-slide>
                    <swiper-slide>
                        <article>
                            <div class="card" data-aos="flip-right" data-aos-delay="450">
                                <img src="@/assets/img/page5-icon8.svg" alt="">
                                <p>
                                    Oferece métricas para avaliar a efetividade do treinamento
                                </p>
                            </div>
                        </article>
                    </swiper-slide>
                    <swiper-slide>
                        <article>
                            <div class="card" data-aos="flip-right" data-aos-delay="550">
                                <img src="@/assets/img/page5-icon9.svg" alt="">
                                <p>
                                    Reduz etapas dos processos seletivos
                                </p>
                            </div>
                        </article>
                    </swiper-slide>
                    <!-- <div class="swiper-button-prev swiper-button-prev1" slot="button-prev"></div>
                    <div class="swiper-button-next swiper-button-next1" slot="button-next"></div> -->
                </swiper>
                <div class="bullets">
                    <div class="swiper-pagination swiper-pagination2" slot="pagination"></div>
                </div>
            </div>
        </div>
    </section>    
</template>
<script>
import { create } from '@lottiefiles/lottie-interactivity';
export default {
    props: ['persona'],
    data() {
        return {
            swiperOptions: {
                slidesPerView: 1,
                centeredSlides: false,
                pagination: {
                    el: '.swiper-pagination2',
                    clickable: true
                },
                navigation: {
                    nextEl: '.swiper-button-next1',
                    prevEl: '.swiper-button-prev1'
                },
                breakpoints: {
                    1140: {
                        slidesPerView: 4,
                    },
                    900: {
                        slidesPerView: 3,
                    }
                }
            }
        }
    },
    computed: {
        swiper() {
        return this.$refs.mySwiper.swiper
        }
    },
    methods: {
        runOnChange(evt) {
            if(this.$refs.mySwiper.$swiper.activeIndex==(this.$refs.mySwiper.$children.length-1)){
                // console.log("FINALIZOU");
            }
        }
    },
    mounted() {
        if(this.persona == 0) {
            this.$refs.lottiepage6.addEventListener('load', function() {
                create({
                        mode:"scroll",
                        player: '#page6anima0',
                        actions: [
                            {
                                visibility: [0, .2],
                                type: "play"
                            }
                        ],
                });
            })
        } else {
            this.$refs.lottiepage6.addEventListener('load', function() {
                create({
                        mode:"scroll",
                        player: '#page6anima1',
                        actions: [
                            {
                                visibility: [0, .2],
                                type: "play"
                            }
                        ],
                });
            })
        }
    }
}
</script>
<style lang="scss" scoped>
section {
    background-color: $color-secondary;
    color: white;
    .container-bottom {
        .swipercards {
            max-width: 100%;
            display: block;
            padding-bottom: 60px;
            article {
                max-width: 248px; 
                background-color: white;
                color: #111A2E;
                margin-left: 10px;
                margin-right: 10px;
                border-radius: 28px;
                box-shadow: 0px 10px 16px 0px rgba(0,0,0,0.16);
                border: 1px solid #B2B2B2;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
                overflow-y: hidden;
                // background-color: red;
                // color: white;
                text-align: center;
                // width: 902px;
                height: 301px;
                padding-left: 30px;
                padding-right: 30px;
                padding-top: 15px;
                padding-bottom: 15px;
                .card {
                    min-height: 240px;
                    flex-grow: 1;
                    color: $color-text-dark;
                    // background-color: white;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    align-items: center;
                    gap: 30px;
                    flex: 1;
                    padding: 30px 20px;
                    border-radius: 28px;
                    // box-shadow: 0px 10px 16px 0px rgba(0,0,0,0.16);
                    // border: 1px solid #B2B2B2;
                    text-align: center;
                    // flex-basis: 25%;
                }
            }
            .bullets {
                // display: none;
                display: flex;
                height: 100px;
                justify-content: center;
            }
        }
    }
    .container {
        padding-top: 56px;
        padding-bottom: 56px;
        // justify-content: flex-start;
        align-items: center;
        .col-left {
            
            align-self: stretch;
            display: flex;
            flex: 1 1 0%;
            flex-direction: column;
            .persona {
                
                max-width: 100%;
                padding-bottom: 46px;
            }
            
            .anima {
                max-height: 450px;
                padding-bottom: 45px;
                max-width: 469px;
                margin: 0 auto;
            }
        }
        .col-right {
            flex-basis: 50%;
            h2 {
                padding-bottom: 30px;
            }
        }
        // .col-right {
        //     flex-basis: 50%;
        //     display: flex;
        //     gap: 30px;
        //     .cards {
        //         flex-basis: 50%;
        //         display: flex;
        //         flex-direction: column;
        //         gap: 30px;
        //         flex-wrap: wrap;
        //         &-right {
        //             margin-top: 120px;
        //             margin-bottom: 120px;
        //         }
        //         .card {
        //             min-height: 240px;
        //             flex-grow: 1;
        //             color: $color-text-dark;
        //             background-color: white;
        //             display: flex;
        //             flex-direction: column;
        //             justify-content: space-around;
        //             align-items: center;
        //             gap: 30px;
        //             flex: 1;
        //             padding: 30px 20px;
        //             border-radius: 28px;
        //             box-shadow: 0px 10px 16px 0px rgba(0,0,0,0.16);
        //             border: 1px solid #B2B2B2;
        //             text-align: center;
        //             // flex-basis: 25%;
        //         }
        //     }
        // }
    }
    .sticky {
        padding-top: 130px;
        position: sticky;
        position: -webkit-sticky;
        overflow: auto;
        top: 0;
    }
    @media only screen and (max-height: 890px) {
        .sticky {
            position: relative;
            // position: -webkit-sticky;
            overflow: auto;
            top: 0;
            padding-top: 0;
        }
    }
    @media only screen and (max-width: 1140px) {
        .container {
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .col-left {
                flex-basis: 100%;
                padding-bottom: 30px;
                text-align: center;
            }
            .col-right {
                flex-basis: 100%;
            }
        }
    }
    @media only screen and (max-width: 600px) {
        .container {
            .swipercards {
                display: block;
                width: 100%;
                article {
                    margin-left: 10px;
                    margin-right: 10px;
                    border-radius: 28px;
                    box-shadow: 0px 10px 16px 0px rgba(0,0,0,0.16);
                    border: 1px solid #B2B2B2;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    overflow-y: hidden;
                    // background-color: red;
                    // color: white;
                    text-align: center;
                    // width: 902px;
                    // height: 253px;
                    padding-left: 30px;
                    padding-right: 30px;
                    padding-top: 15px;
                    padding-bottom: 15px;
                }
                .bullets {
                    height: 100px;
                    display: flex;
                    justify-content: center;
                }
            }
            .col-right {
                display: none;
                flex-direction: column;
                .cards-right {
                    margin-top: 0;
                    margin-bottom: 0;
                }
            }
        }
    }
}
</style>